import { r as registerInstance, f as forceUpdate, h, H as Host } from './index-DFuxYijk.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-CeCrhl7U.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Enable file upload in the form
         */
        this.fileUpload = false;
        /**
         * data that should be prefilled in the form
         * @optional
         */
        this.prefillData = null;
        /**
         * The locale to use for translations and the phone input
         */
        this.locale = "en-US";
        /**
         * Environment string to decide which endpoints to use
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * open modal automatically
         */
        this.open = false;
        /** URL to be opened when the modal is closed */
        this.reloadUrl = "";
        /**
         * origin application of the request, e.g. 'oseon' or 'MyTRUMPF'
         */
        this.origin = "";
        this.submitted = false;
        this.handleModalClose = () => {
            if (this.reloadUrl && this.reloadUrl.length > 0) {
                window.location.href = this.reloadUrl;
                return;
            }
            window.location.reload();
        };
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    componentDidLoad() {
        if (this.open) {
            this.modal.triggerOpen();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    handleServiceCaseShowSuccess() {
        this.submitted = true;
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        return (h(Host, { key: '9dc9b1b2b9e61b1b4bff5b7dfaecfbfb4a63227f' }, h("ux-modal", { key: 'b86d13c8ff12e6f6d5f5af9afcaf9016f81c2f7c', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '37904041fe43715d6c27475831dadeb4324297f7' }, h("mf-create-service-case", { key: '43c9ba4abc7af6c381a9d6be9ea6f049018577a1', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi, origin: this.origin }, h("slot", { key: '95ee272658a54c5b08d4a9c0d279a4bc7a269851', name: "connector" }))), this.submitted && (h("ux-modal-footer", { key: '5e75f9a76aec4530231227fa70ce9614bd94183d' }, h("ux-button", { key: '279e49a952598acb126d6c70b535d671d67012ae', variant: "primary", onClick: () => {
                this.modal.triggerClose();
            } }, t("button.ok")))))));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };
//# sourceMappingURL=mf-create-service-case-modal.entry.js.map

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map